import { LitElement, html, css } from 'lit'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'

customElements.define('k-review-card', class extends LitElement{

    static styles = css`
        :host {
            display: block;
            position:relative;
        }

        b-paper {
            border: 1px solid var(--blue-muted);
            text-align: left;
        }

        img {
            height: auto;
            width: 100%;
            clip-path: polygon(10% 0%, 100% 0%, 90% 100%, 0% 100%);
            max-height: 30vw;
            width: 200px;
            object-fit: cover;
        }

    `

    render(){return html`
        <b-paper outline>
            <b-grid cols="auto,1" cols-mobile="1" gap-col=2>
                ${unsafeHTML(this.data.imgs.medium)}

                <b-grid cols=1>
                
                    <k-h2 href=${this.data.social}>${this.data.name}</k-h2>

                    <b-text italic .html=${this.data.pull_quote||this.data.content}></b-text>

                    <b-text align=right>
                    <b-btn clear href=${this.data.link}>Full review</b-btn>
                    </b-text>

                </b-grid>

            </b-grid>
        

        </b-paper>
    `}

})

export default customElements.get('k-review-card')